@if (showAccountSelection$ | async) {
  <button
    mat-stroked-button
    [disabled]="heidiService.loading()"
    [matMenuTriggerFor]="accountMenu"
  >
    @if (heidiService.loading()) {
      <mat-spinner diameter="20" />
    } @else {
      <div class="flex items-center gap-2">
        <mat-icon class="icon-xs opacity-70">auto_awesome</mat-icon>
        <span>AI Notes</span>
      </div>
    }
  </button>

  <mat-menu #accountMenu="matMenu" xPosition="before" class="w-64">
    <ng-template matMenuContent>
      <div class="px-4 py-2 text-xs font-bold text-gray-600">
        Select Heidi Account
      </div>

      <mat-divider />

      @for (account of heidiAccounts$ | async; track account.email) {
        <button
          mat-menu-item
          class="!h-auto !py-3"
          (click)="openHeidiWidget(account)"
        >
          <div class="flex flex-col">
            <span class="text-sm text-gray-900">
              {{ account.name }}
            </span>
            <span class="text-xs text-gray-500">{{ account.email }}</span>
          </div>
        </button>
      }
    </ng-template>
  </mat-menu>
} @else {
  <button
    #overlayTarget="cdkOverlayOrigin"
    cdkOverlayOrigin
    mat-stroked-button
    [disabled]="heidiService.loading()"
    (click)="openDefaultAccount()"
  >
    @if (heidiService.loading()) {
      <mat-spinner diameter="20" />
    } @else {
      <div class="flex items-center gap-2">
        <mat-icon class="icon-xs opacity-70">auto_awesome</mat-icon>
        <span>AI Notes</span>
      </div>
    }
  </button>

  <pt-custom-tooltip
    [target]="overlayTarget"
    [positions]="tooltipPositions"
    [disabled]="(hasAnyAccount$ | async) !== false"
  >
    <ng-template ptCustomTooltipContent>
      <pr-ai-notes-marketing-tooltip (connectAccount)="openAccountSettings()" />
    </ng-template>
  </pt-custom-tooltip>
}
